// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "@firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyDPInFu80TMhr-ct4zZSxRsYvaEzjulhZ4",
    authDomain: "chatapp-34f86.firebaseapp.com",
    projectId: "chatapp-34f86",
    storageBucket: "chatapp-34f86.appspot.com",
    messagingSenderId: "353661205309",
    appId: "1:353661205309:web:b51ae979de4f8a462ae354",
    measurementId: "G-1Q8JYTFTE0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();